import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItalic = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.16602 15.8327V13.7493H7.49935L9.99935 6.24935H6.66602V4.16602H14.9993V6.24935H12.0827L9.58268 13.7493H12.4993V15.8327H4.16602Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgItalic);
export { ForwardRef as ReactComponent };
